/**
 * Derive up to two initials from a display name.
 * Returns null when no letter characters are available.
 */
export default function initialsFromName(displayName) {
  if (!displayName || typeof displayName !== 'string') {
    return null;
  }

  const parts = displayName
    .trim()
    .split(/\s+/)
    .map(part => part.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean);

  if (parts.length === 0) {
    return null;
  }

  if (parts.length === 1) {
    const word = parts[0];
    return word.slice(0, Math.min(2, word.length)).toUpperCase();
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
